var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAddCircleOutline(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "add-circle-outline"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.0002 5.33325C17.2802 5.33325 5.3335 17.2799 5.3335 31.9999C5.3335 46.7199 17.2802 58.6666 32.0002 58.6666C46.7202 58.6666 58.6668 46.7199 58.6668 31.9999C58.6668 17.2799 46.7202 5.33325 32.0002 5.33325ZM29.3335 18.6666V29.3333H18.6668V34.6666H29.3335V45.3333H34.6668V34.6666H45.3335V29.3333H34.6668V18.6666H29.3335ZM10.6668 31.9999C10.6668 43.7599 20.2402 53.3333 32.0002 53.3333C43.7602 53.3333 53.3335 43.7599 53.3335 31.9999C53.3335 20.2399 43.7602 10.6666 32.0002 10.6666C20.2402 10.6666 10.6668 20.2399 10.6668 31.9999Z",
    fill: "#C7D6FF"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddCircleOutline);
export default __webpack_public_path__ + "static/media/add-circle-outline.dd5829fcbcb5016971174d6635c94291.svg";
export { ForwardRef as ReactComponent };